export default function removeHttp(link: string): string {
  if (link.startsWith("https://")) {
    return link.slice(8)
  } else if (link.startsWith("http://")) {
    return link.slice(7)
  } else {
    return link
  }
}
